/**
 * File source-track.js.
 * Track user enrollment source and paid source via custom attributes
 */

function sourceTrackInit($) {
  const pageUrl = getPath();
  const isAd = globalSearchParams.has('ad');
  const isReferral = (pageUrl.indexOf('/r/') !== -1);
  let pSource = null;

  // set enrollment source
  const eSource = isReferral ? 'referral' :
                  isAd ? 'paid' :
                  'organic';

  // if source is paid, also set paid source
  if (eSource == 'paid') {
    const adParamVal = globalSearchParams.get('ad');

    function adValContains(...vals) {
      for (let i = 0; i < vals.length; i++) {
        if (adParamVal.indexOf(vals[i]) !== -1) {
          return true;
        }
      }
      return false;
    }

    pSource = (adValContains('fb_')) ? 'Facebook' :
              (adValContains('sn_')) ? 'Snapchat' :
              (adValContains('ig_')) ? 'Instagram' :
              (adValContains('gsearch_', 'g_')) ? 'Google' :
              null;
  }

}
